/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';
import { useAccount } from 'wagmi';
import FunAbi from '../config/PumpFunAbi.json';
import TokenAbi from '../config/TokenAbi.json';
import { readContract, writeContract } from '@wagmi/core';
import { waitForTransaction } from '@wagmi/core';
import Web3 from 'web3';
import { toast } from 'react-hot-toast';
import ClaimCard from '../components/ClaimCard.jsx';
import bnb from '../icons/bnb.svg';
import eth from '../icons/ETH.svg';
import pol from '../icons/polygon.svg';
import tao from '../icons/tao.png';
import uniswapBannerImg from '../icons/pancakeswap_banner.png';
import swapIconDark from '../icons/swapIconDark.png';
import swapIconLight from '../icons/swapIconLight.png';
import TopBar from '../components/TopBar';
import ClipLoader from 'react-spinners/ClipLoader';
import { useQueryParam, StringParam } from 'use-query-params';
import MyChart from '../components/Chart.jsx';
import Chart from '../components/tradingview/index.js';
import CopyIcon from '../icons/copy.svg';
import rot13 from '../utils/encode.ts';
import { web3Clients, imageUrl, apiUrl, ethPriceApiUrl, scanApiLinks, apiKeys, chainNames1, scanLinks, chainNames, coinNames, projectName, supportedChainIds } from '../utils/constants.ts';
import { getDefaultAddress } from '../utils/addressHelpers.ts';
import { config } from '../config.jsx';
import { BASE_URL } from '../utils/constants.ts';
import CustomRadioButton from '../components/CustomRadioButton';
import { SignMessage } from './SignMessage.jsx';
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import Footer from '../components/Footer';
import MultiCallAbi from '../config/MultiCallAbi.json';
import { getMulticallAddress } from '../utils/addressHelpers.ts';

/** Contract may revert with misleading reasons when minOut is too strict; treat as slippage. */
const isSlippageSwapError = (err) => {
  const parts = [];
  let current = err;
  for (let i = 0; i < 6 && current; i++) {
    parts.push(
      current.message,
      current.shortMessage,
      current.details,
      current.reason,
      current.cause?.message
    );
    current = current.cause;
  }
  const msg = parts.filter(Boolean).join(' ').toLowerCase();
  return (
    msg.includes('slippage') ||
    msg.includes('gas limit too high') ||
    msg.includes('minethout') ||
    msg.includes('mintokensout') ||
    msg.includes('insufficient output')
  );
};

// Helper component for token logo with fallback support
const TokenLogo = ({ logoUrl, tokenName, className = "w-10 h-10 rounded-full", alt = "" }) => {
  const [currentUrl, setCurrentUrl] = useState(logoUrl);
  const [hasTriedFallback, setHasTriedFallback] = useState(false);

  useEffect(() => {
    setCurrentUrl(logoUrl);
    setHasTriedFallback(false);
  }, [logoUrl]);

  const getFallbackUrl = (url, tokenName) => {
    if (!url || !tokenName) return url;
    try {
      const parts = url.split('/');
      const filename = parts[parts.length - 1];
      const escapedTokenName = tokenName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const fallbackFilename = filename.replace(new RegExp(`^${escapedTokenName}-`), `${projectName}-`);
      if (fallbackFilename !== filename) {
        parts[parts.length - 1] = fallbackFilename;
        return parts.join('/');
      }
    } catch (error) {
      console.error('Error constructing fallback URL:', error);
    }
    return url;
  };

  const handleError = () => {
    if (!hasTriedFallback && logoUrl) {
      setHasTriedFallback(true);
      const fallback = getFallbackUrl(logoUrl, tokenName);
      if (fallback !== logoUrl) {
        setCurrentUrl(fallback);
      }
    }
  };

  if (!currentUrl) return null;

  return (
    <img
      src={currentUrl}
      className={className}
      alt={alt || tokenName}
      onError={handleError}
    />
  );
};


const App = () => {
  const ethIcon = {
    1: eth,
    56: bnb,
    11155111: eth,
    8453: eth,
    137: pol,
    10321: tao,
    97: bnb,
  };
  let [addressDatas] = useQueryParam('address', StringParam);
  let FunAddress;
  let ref;
  if (addressDatas.includes('/?ref=')) {
    FunAddress = addressDatas.split('/?ref=')[0];
    ref = addressDatas.split('/?ref=')[1];
  } else {
    FunAddress = addressDatas;
  }
  let [chainId] = useQueryParam('chain', StringParam);
  const { address } = useAccount();
  const [tokenName, setTokenName] = useState('');
  const [tokenSymbol, setTokenSymbol] = useState('');
  const [maxLimit, setMaxLimit] = useState(1);
  const [tokenAddress, setTokenAddress] = useState('');
  // Use tokenName format first (for privacy wallet), will fallback to projectName format
  const [tokenLogo, setTokenLogo] = useState(imageUrl + 'logo/' + projectName + "-" + chainId + "-" + FunAddress + '.png');
  const [tokenBanner, setTokenBanner] = useState(imageUrl + 'logo/' + projectName + "-" + chainId + "-" + FunAddress + '.png');
  const [virtualLp, setVirtualLiquidiity] = useState(0);
  const [maxBuyAmount, setMaxBuyAmount] = useState(2);
  const [tokenAmount, setAmount] = useState();
  const [tokenOutAmount, setTokenOutAmount] = useState(0);
  let [accountBalance, setAccountBalance] = useState(0);
  let [, setInputBalance] = useState(0);
  let [tokenBalance, setTokenBalance] = useState(0);
  let [tokenAllowance, setTokenAllowance] = useState(0);
  const [slippage, setSlippage] = useState(1); // Default 1% slippage
  const [virtualTokenLp, setVirtualTokenLp] = useState();
  const [tokenPrice, setTokenPrice] = useState(0);
  let [creating, setCreating] = useState(false);
  const [website, setWebsite] = useState();
  const [twitter, setTwitter] = useState();
  const [telegram, setTelegram] = useState();
  const [inputToken, setInputToken] = useState('ETH');
  const [transactions, setTransactions] = useState([]);
  const [transactionDatas, setTransactionDatas] = useState([]);
  const [tokenPriceDatas, setTokenPriceDatas] = useState();
  const [volume, setVolume] = useState(0);
  const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false);
  const [contractAddress, setContractAddress] = useState('');
  const [devAddress, setDevAddress] = useState('');
  const [, setRouterAddress] = useState('');
  const [description, setDescription] = useState('');
  const { theme, toggleTheme } = useTheme();
  const [refCounts, setRefCounts] = useState(0);
  const [totalRefAmounts, setTotalRefAmounts] = useState(0);
  const [refUserAmount, setRefUserAmout] = useState(0);
  const [lpCreated, setLpCreated] = useState(false);
  const [ethPrice, setEthPrice] = useState();
  const [chatHistory, setChatHistory] = useState([]);
  const [chatContent,] = useState('');
  const [marketCap, setMarketCap] = useState(0);
  const [depositedAmount, setDepositedAmount] = useState(0);
  let [loading, setLoading] = useState(false);
  const [virtualLpTokenAmounts, setVirtualLpTokenAmounts] = useState(0);
  // Format number with 3 decimal places (same as LaunchpadCard)
  const formatNumber = (num) => {
    if (!num || isNaN(num)) return '0.000';
    if (num >= 1e12) return (num / 1e12).toFixed(3) + 'T';
    if (num >= 1e9) return (num / 1e9).toFixed(3) + 'B';
    if (num >= 1e6) return (num / 1e6).toFixed(3) + 'M';
    if (num >= 1e3) return (num / 1e3).toFixed(3) + 'K';
    return num.toFixed(3);
  };

  // Format price with 6 decimal places
  const formatPrice = (num) => {
    if (!num || isNaN(num)) return '0.000000';
    return num.toFixed(6);
  };

  // Format trade amount with max 4 digits total (including decimal)
  // Examples: 1000 → 1K, 1000000 → 1M, 1234567 → 1.235M
  const formatTradeAmount = (num) => {
    if (!num || isNaN(num)) return '0';
    const numValue = Number(num);
    
    // Helper function to format with max 4 digits
    // Helper function to format with exactly 4 digits total
    const formatTo4Digits = (value, suffix) => {
      if (value >= 1000) {
        // 4 digits: 1000-9999 → show as integer
        return Math.round(value).toString() + suffix;
      }
      if (value >= 100) {
        // 3 digits: 100-999 → show as integer
        return Math.round(value).toString() + suffix;
      }
      if (value >= 10) {
        // 2 digits: 10-99 → show 1 decimal (e.g., 12.3K = 4 digits)
        return value.toFixed(1) + suffix;
      }
      // 1 digit: 1-9 → show 3 decimals (e.g., 1.235M = 4 digits)
      // Round to 3 decimal places to ensure exactly 4 digits
      const rounded = Math.round(value * 1000) / 1000;
      return rounded.toFixed(3) + suffix;
    };
    
    // For numbers >= 1 trillion
    if (numValue >= 1e12) {
      return formatTo4Digits(numValue / 1e12, 'T');
    }
    
    // For numbers >= 1 billion
    if (numValue >= 1e9) {
      return formatTo4Digits(numValue / 1e9, 'B');
    }
    
    // For numbers >= 1 million
    if (numValue >= 1e6) {
      return formatTo4Digits(numValue / 1e6, 'M');
    }
    
    // For numbers >= 1 thousand
    if (numValue >= 1e3) {
      return formatTo4Digits(numValue / 1e3, 'K');
    }
    
    // For numbers < 1000, show up to 4 digits total
    if (numValue >= 100) {
      return numValue.toFixed(0);
    }
    if (numValue >= 10) {
      return numValue.toFixed(1);
    }
    if (numValue >= 1) {
      return numValue.toFixed(2);
    }
    // For numbers < 1, show up to 4 digits
    const str = numValue.toFixed(4);
    // Remove trailing zeros but keep at least one digit after decimal if needed
    return parseFloat(str).toString();
  };

  let max =
    '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';

  const cookies = new Cookies();
  if (ref) {
    if (Web3.utils.isAddress(rot13(ref))) {
      cookies.set('ref', ref);
    }
  }
  
  // Get refAddress - ensure it's always defined
  const getRefAddress = () => {
  if (cookies.get('ref')) {
      const decodedRef = rot13(cookies.get('ref'));
      if (Web3.utils.isAddress(decodedRef)) {
        return decodedRef;
      }
    }
    // Get default address for current chain, with fallback to zero address
    const currentChainId = chainId ? Number(chainId) : undefined;
    const defaultAddr = getDefaultAddress(currentChainId);
    if (defaultAddr && defaultAddr !== '' && Web3.utils.isAddress(defaultAddr)) {
      return defaultAddr;
    }
    // Fallback to zero address if default address is not available
    return '0x0000000000000000000000000000000000000000';
  };
  const REF_URL = BASE_URL + '/buy/?chain=' + chainId + '&address=' + FunAddress
  const referlink = address ? `${REF_URL}/?ref=${rot13(address)}` : `${REF_URL}/?ref=`

  const copyAddress = address => async e => {
    e.stopPropagation();
    e.preventDefault();
    if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('textarea');
      ele.value = address;
      document.body.appendChild(ele);
      ele.select();
      document.execCommand('copy');
      document.body.removeChild(ele);
      toast.success('Copied to clipboard');
      // displayTooltip();
    }
  };

  function displayTooltip() {
    let timeoutId;
    setIsTooltipDisplayed(true);
    timeoutId = setTimeout(() => {
      setIsTooltipDisplayed(false);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }

  const onTokenSwap = async () => {
    try {
      // Validate inputs
      if (!tokenAmount || Number(tokenAmount) <= 0) {
        toast.error('Please enter a valid amount');
        return;
      }

      if (!address) {
        toast.error('Please connect your wallet');
        return;
      }

      setCreating(true);
      let swap;
      let sendData;
      
      if (inputToken === 'ETH') {
        // Buy token validation
        const ethAmount = Number(tokenAmount);
        if (ethAmount > accountBalance) {
          toast.error("Insufficient balance");
          setCreating(false);
          return;
        }
        
        // if (tokenOutAmount + Number(tokenBalance) > 1000000000 * maxBuyAmount / 100) {
        //   toast.error("You can't purchase more than max buy limit");
        //   setCreating(false);
        //   return;
        // }

        const minTokensOut = (tokenOutAmount > 0 ? tokenOutAmount * (1 - slippage / 100) : 0);
        const minTokensOutWei = minTokensOut > 0
          ? web3Clients[chainId].utils.toWei(String(minTokensOut.toFixed(18)), 'ether')
          : '0';
        swap = await writeContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'buyToken',
          value: web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'),
          args: [getRefAddress(), minTokensOutWei],
          chainId: Number(chainId)
        });
        await waitForTransaction(config, {
          hash: swap,
        });
        sendData = {
          chainId,
          buyer: address,
          type: 'bought',
          name: tokenSymbol,
          amount: tokenAmount,  // eth amount
          token: tokenAddress,
          contract: FunAddress, // Use FunAddress (presale contract) instead of contractAddress
          timestamp: (Date.now() / 1000).toFixed(0),
        };
      } else if (inputToken === 'TOKEN' || inputToken === 'Token') {
        // Sell token validation
        const tokenAmountNum = Number(tokenAmount);
        
        if (tokenAmountNum > tokenBalance) {
          toast.error("Insufficient token balance");
          setCreating(false);
          return;
        }


        // Check if we need to approve first
        if (tokenAllowance < tokenAmountNum) {
          let approve;
          let approveAddress;
          approveAddress = FunAddress;
          approve = await writeContract(config, {
            address: tokenAddress,
            abi: TokenAbi,
            functionName: 'approve',
            args: [approveAddress, max],
            chainId: Number(chainId)
          });
          await waitForTransaction(config, {
            hash: approve,
          });
          toast.success("Successfully approved tokens");
          
          // Refresh allowance after approval
          const newAllowance = await readContract(config, {
            address: tokenAddress,
            abi: TokenAbi,
            functionName: 'allowance',
            args: [address, approveAddress],
            chainId: Number(chainId)
          });
          setTokenAllowance(Number(newAllowance) / 10 ** 18);
          
          // Continue with sell after approval
          if (Number(newAllowance) / 10 ** 18 < tokenAmountNum) {
            toast.error("Approval failed or insufficient allowance");
            setCreating(false);
            return;
          }
          }

          const minEthOut = (tokenOutAmount > 0 ? tokenOutAmount * (1 - slippage / 100) : 0);
          const minEthOutWei = minEthOut > 0
            ? web3Clients[chainId].utils.toWei(String(minEthOut.toFixed(18)), 'ether')
            : '0';
          swap = await writeContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'sellToken',
            args: [web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'), getRefAddress(), minEthOutWei],
            chainId: Number(chainId)
          });

          await waitForTransaction(config, {
            hash: swap,
          });
          sendData = {
            chainId,
            buyer: address,
          type: 'sold',
            name: tokenSymbol,
            amount: tokenAmount,
            token: tokenAddress,
          contract: FunAddress, // Use FunAddress (presale contract) instead of contractAddress
            timestamp: (Date.now() / 1000).toFixed(0)
          };
      }
      if (sendData) {
        const response = await fetch(apiUrl + '/addHistory', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: 'error',
          body: JSON.stringify(sendData)
        });
        if (response.status !== 200) {
          const { error } = await response.json();
          throw new Error(error);
        }
      }
      toast.success(`Successfully ${inputToken !== 'ETH' ? Number(tokenAmount).toLocaleString() + " " + tokenSymbol : Number(tokenAmount) + " " + coinNames[chainId]} swapped`);
      
      // Refresh balances after successful swap
      setTimeout(function () {
        setCreating(false);
        // Trigger balance refresh by clearing tokenAmount temporarily
        const tempAmount = tokenAmount;
        setAmount('');
        setTimeout(() => setAmount(tempAmount), 100);
      }, 2000);
    } catch (err) {
      console.error('Swap error:', err);
      setCreating(false);

      const errMsg = err?.message || '';

      if (isSlippageSwapError(err)) {
        toast.error('Slippage error. Please try again with a higher slippage');
      } else if (errMsg.includes('insufficient') || errMsg.includes('balance')) {
        toast.error('Insufficient balance for this transaction');
      } else if (errMsg.includes('user rejected') || errMsg.includes('User rejected')) {
        toast.error('Transaction rejected by user');
      } else if (errMsg.includes('allowance')) {
        toast.error('Insufficient token allowance. Please approve tokens first.');
      } else if (inputToken === 'ETH' && (tokenOutAmount + Number(tokenBalance) > 1000000000 * maxBuyAmount / 100)) {
        const remainTokenAmount = 1000000000 * maxBuyAmount / 100 - Number(tokenBalance);
        toast.error("You can't purchase more than " + remainTokenAmount.toLocaleString() + ' ' + tokenSymbol);
      } else {
        toast.error(errMsg || 'There is a problem with your Swap. Please try again later');
      }
    }
  };

  useEffect(() => {
    const FetchData = async () => {
      try {
        const FunInfo = await readContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'getFunBasicInfo',
          chainId: Number(chainId)
        });

        // Get virtualLpTokenAmount for THIS presale by matching FunAddress in multicall mainInfo[5]
        try {
          const mainInfo = await readContract(config, {
            address: getMulticallAddress(Number(chainId)),
            abi: MultiCallAbi,
            functionName: 'getMainInfo',
            chainId: Number(chainId),
          });

          const addresses = Array.isArray(mainInfo?.[5]) ? mainInfo[5] : [];
          const index = addresses.findIndex(
            (addr) => String(addr).toLowerCase() === String(FunAddress).toLowerCase()
          );

          if (index >= 0 && mainInfo?.[1]?.[index] !== undefined) {
            const virtualLpTokenAmount = Number(mainInfo[1][index]) / 10 ** 18;
            setVirtualLpTokenAmounts(virtualLpTokenAmount);
          } else {
            // Fallback to fun contract basic info if multicall mapping not found
            setVirtualLpTokenAmounts(Number(FunInfo[0][4]) / 10 ** 18);
          }
        } catch (e) {
          console.warn('getMainInfo failed:', e);
          // Fallback to fun contract basic info
          setVirtualLpTokenAmounts(Number(FunInfo[0][4]) / 10 ** 18);
        }

        const AllPriceInfo = await readContract(config, {
          address: FunAddress,
          abi: FunAbi,
          functionName: 'getAllPrices',
          chainId: Number(chainId)
        })

        await fetch(
          ethPriceApiUrl[chainId],
          {
            method: 'GET'
          }
        ).then(async res => {
          let data = await res.json()
          const ethPriceValue = Object.values(data)[0]?.usd;
          setEthPrice(ethPriceValue)
          // Calculate values same as board.jsx
          const tokenPriceValue = Number(FunInfo[0][8]);
          // Price: (tokenPrice * ethPrice) / 10 ** 12
          const calculatedPrice = (tokenPriceValue * ethPriceValue) / 10 ** 12;
          // Market Cap: (tokenPrice * 1000000000 * ethPrice) / 10 ** 12
          const calculatedMarketCap = (tokenPriceValue * 1000000000 * ethPriceValue) / 10 ** 12;
          // Volume: (depositedAmount * ethPrice) / 10 ** 18 (FunInfo[0][9] is depositedAmount in wei)
          const calculatedVolume = (Number(FunInfo[0][9]) * ethPriceValue) / 10 ** 18;
          
          setMarketCap(calculatedMarketCap);
          setVolume(calculatedVolume);
        })
        setTokenPriceDatas(AllPriceInfo)
        setTokenName(FunInfo[1][0])
        setTokenSymbol(FunInfo[1][1])
        // Update logo and banner URLs to use tokenName format (for privacy wallet compatibility)
        // Will fallback to projectName format if tokenName format fails
        if (FunInfo[1][0]) {
          setTokenLogo(imageUrl + 'logo/' + FunInfo[1][0] + "-" + chainId + "-" + FunAddress + '.png');
          setTokenBanner(imageUrl + 'logo/' + FunInfo[1][0] + "-" + chainId + "-" + FunAddress + '.png');
        }
        setTokenAddress(FunInfo[2][1])
        setMaxLimit(Number(FunInfo[0][2]))
        setVirtualLiquidiity(Number(FunInfo[0][5]) / 10 ** 18)
        setVirtualTokenLp(Number(FunInfo[0][4]) / 10 ** 18)
        setTokenPrice(Number(FunInfo[0][8]))
        setMaxBuyAmount(Number(FunInfo[0][2]))
        setWebsite(FunInfo[1][2])
        setTwitter(FunInfo[1][3])
        setTelegram(FunInfo[1][4])
        setContractAddress(FunInfo[2][0])
        setDevAddress(FunInfo[2][2])
        setRouterAddress(FunInfo[2][3])
        setRefCounts(Number(FunInfo[0][7]))
        setTotalRefAmounts(Number(FunInfo[0][6]) / 10 ** 18)
        setDescription(FunInfo[1][6])
        setLpCreated(FunInfo[4])

        if (address) {
          let accountBalance = await web3Clients[chainId].eth.getBalance(address);
          accountBalance = web3Clients[chainId].utils.fromWei(accountBalance, 'ether');
          setAccountBalance(accountBalance);
          if (inputToken === 'ETH') {
            setInputBalance(accountBalance);
          } else if (inputToken === 'TOKEN' || inputToken === 'Token') {
            setInputBalance(tokenBalance);
          }
          const refUserAmounts = await readContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'refAmounts',
            args: [address],
            chainId: Number(chainId)
          });
          setRefUserAmout(Number(refUserAmounts) / (10 ** 18));

        }
      } catch (e) {
        console.error(e);
      }
    };
    if (creating === false) {
      FetchData();
    }
  }, [chainId, creating, FunAddress, address, web3Clients[chainId].eth, web3Clients[chainId].utils, inputToken, tokenBalance])

  const getApi = async () => {
    const AllPriceInfo = await readContract(config, {
      address: FunAddress,
      abi: FunAbi,
      functionName: 'getAllPrices',
      chainId: Number(chainId)
    })
    setTokenPriceDatas(AllPriceInfo)

    try {
      await fetch(
        ethPriceApiUrl[chainId],
        {
          method: 'GET'
        }
      ).then(async res => {
        let data = await res.json();
        setEthPrice(Object.values(data)[0]?.usd);
      });
    } catch (e) {
      console.error(e);
    }

    try {
      await fetch(
        apiUrl + `/getOne/${FunAddress}`,
        {
          method: 'GET'
        }
      ).then(async res => {
        let data = await res.json();
        if (!data.message) {
          let history;
          let historyData = [];
          for (let i = 0; i < data?.length; i++) {
            let sender = data[i].sender;
            let content = data[i].content;
            let currentDate = Date.now();
            let date = currentDate / 1000 - Number(data[i].timestamp);
            if (date > 86400) {
              date = (date / 86400).toFixed(0) + ' days ago';
            } else if (date > 3600) {
              date = (date / 3600).toFixed(0) + ' hours ago';
            } else if (date > 0) {
              date = (date / 60).toFixed(0) + ' mins ago';
            } else {
              date = ' just now';
            }
            let userAvatarUrl = imageUrl + `profile-${sender}.png`;
            history = { Sender: sender, Content: content, Date: date, avatar: userAvatarUrl };
            historyData.push(history);
          }
          setChatHistory(historyData);
        }
      });
    } catch (e) {
      console.error(e);
    }

    // get transaction
    try {
      if (FunAddress) {
        await fetch(
          `${scanApiLinks[chainId]}?module=account&action=txlist&address=${FunAddress}&startblock=0&endblock=99999999&apiKey=${apiKeys[chainId]}`,
          {
            method: 'GET'
          }
        ).then(async res => {
          let data = await res.json();
          if (data.status === "1") {
            setTransactions(data.result.filter(item => item.isError === "0"));
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => getApi(), 10000);
    return () => clearInterval(interval);
  }, []);

  const setMaxAmount = async () => {
    if (accountBalance > 0) accountBalance = accountBalance - 0.00001;
    if (inputToken === 'ETH') {
      setAmount(accountBalance);
    } else if (inputToken === 'TOKEN' || inputToken === 'Token') {
      setAmount(tokenBalance);
    }
  };

  useEffect(() => {
    const FetchAmount = async () => {
      try {
        const sideId = inputToken === 'ETH' ? 1 : 0;
        let amounts;
        if (Number(tokenAmount) > 0) {
          amounts = await readContract(config, {
            address: FunAddress,
            abi: FunAbi,
            functionName: 'ethOrTokenAmount',
            args: [web3Clients[chainId].utils.toWei(String(tokenAmount), 'ether'), sideId],
            chainId: Number(chainId)
          });

          setTokenOutAmount(Number((Number(amounts) / 10 ** 18).toFixed(6)));
        } else {
          setTokenOutAmount('');
        }
      } catch (e) {
        console.error(e);
      }
    };
    if (creating === false) {
      FetchAmount();
    }
  }, [inputToken, tokenAmount, creating]);

  const chanageCurrency = async () => {
    if (inputToken === 'ETH') {
      setInputToken('TOKEN');
      setInputBalance(tokenBalance);
      setAmount(tokenOutAmount);
    } else {
      setInputToken('ETH');
      setInputBalance(accountBalance);
      setAmount(tokenOutAmount);
    }
  };
  useEffect(() => {
    const FetchAmount = async () => {
      try {
        let amounts;
        amounts = await readContract(config, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'balanceOf',
          args: [address],
          chainId: Number(chainId)
        });
        let allowance;
        let approveAddress;
        approveAddress = FunAddress;
        allowance = await readContract(config, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'allowance',
          args: [address, approveAddress],
          chainId: Number(chainId)
        });
        setTokenAllowance(Number(allowance) / 10 ** 18);
        setTokenBalance((Math.floor(web3Clients[chainId].utils.fromWei(String(amounts), 'ether'))));
      } catch (e) {
        console.error(e);
      }
    };
    if (address && tokenAddress) {
      FetchAmount();
    }
  }, [tokenAddress, address, creating]);

  useEffect(() => {
    const FetchTransaction = async () => {
      if (!FunAddress || !chainId) {
        console.log('FetchTransaction: Missing FunAddress or chainId', { FunAddress, chainId });
        return;
      }
      
      try {
        // console.log('FetchTransaction: Fetching from API', { FunAddress, chainId });
        const response = await fetch(
          apiUrl + `/getTradeHistory`,
          {
            method: 'GET'
          }
        );
        
        if (!response.ok) {
          console.error('FetchTransaction: API response not OK', response.status, response.statusText);
          setTransactionDatas([]);
          return;
        }
        
        const data = await response.json();
        // console.log('FetchTransaction: API response', { dataLength: data?.length, data });
        // console.log('FetchTransaction: Looking for', { FunAddress, chainId: Number(chainId) });
        
        if (data && Array.isArray(data) && data.length > 0) {
        let transactionData = [];
          // Filter trades by contract address and chainId
          for (let i = 0; i < data.length; i++) {
            // Log first item to see structure
            if (i === 0) {
              // console.log('FetchTransaction: Sample data item', {
              //   contract: data[i].contract,
              //   chainId: data[i].chainId,
              //   chainIdType: typeof data[i].chainId,
              //   allFields: Object.keys(data[i])
              // });
            }
            
            // Try multiple field name variations
            const contractField = data[i].contract || data[i].presaleAddress || data[i].address || data[i].contractAddress;
            const chainIdField = data[i].chainId !== undefined ? data[i].chainId : data[i].chain;
            
            const contractMatch = contractField && 
              contractField.toLowerCase() === FunAddress.toLowerCase();
            const chainMatch = Number(chainIdField) === Number(chainId);
            
            // console.log(`FetchTransaction: Item ${i}`, {
            //   contractField,
            //   chainIdField,
            //   contractMatch,
            //   chainMatch,
            //   willInclude: contractMatch && chainMatch
            // });
            
            if (contractMatch && chainMatch) {
              let amount = data[i].amount;
              let buyer = data[i].buyer;
              let name = data[i].name;
              let token = data[i].token;
              let type = data[i].type;
              let contract = data[i].contract;
              let txHash = data[i].txHash || data[i].hash || data[i].transactionHash || null;
              let currentDate = Date.now();
              let timestamp = currentDate / 1000 - Number(data[i].timestamp);
              let date;
              if (timestamp > 86400) {
                date = (timestamp / 86400).toFixed(0) + ' days ago';
              } else if (timestamp > 3600) {
                date = (timestamp / 3600).toFixed(0) + ' hours ago';
              } else if (timestamp > 0) {
                date = (timestamp / 60).toFixed(0) + ' mins ago';
            } else {
              date = ' just now';
            }
              
              // Convert amount from wei to decimal (divide by 10^18) if needed
              // Check if amount is in wei format (very large integer number)
              let amountNum = Number(amount);
              // If amount is greater than 1e15 and appears to be in wei format, convert to decimal
              // Most token amounts in decimal will be less than 1e15, while wei amounts are typically 1e18+
              if (amountNum >= 1e15 && Number.isInteger(amountNum)) {
                amountNum = amountNum / (10 ** 18);
            }
              
              // Format amount with K/M/B/T suffixes, max 4 digits total
              let formattedAmount = formatTradeAmount(amountNum);
              
              // Normalize type
              let normalizedType = type;
              if (type === 'bought') {
                normalizedType = 'Buy';
              } else if (type === 'sold' || type === 'Sold') {
                normalizedType = 'Sell';
              }
              
              let transaction = {
                Maker: buyer,
                Type: normalizedType,
                Amount: formattedAmount,
                Date: date,
                Tx: txHash || buyer + '-' + data[i].timestamp, // Use buyer+timestamp as unique key if no tx hash
                txHash: txHash, // Store actual tx hash if available
                timestamp: Number(data[i].timestamp) // Store original timestamp for sorting
            };
            transactionData.push(transaction);
          }
        }
          // console.log('FetchTransaction: Filtered transactions', { count: transactionData.length, transactions: transactionData });
          // Sort by timestamp (newest first) - descending order
          transactionData.sort((a, b) => b.timestamp - a.timestamp);
          setTransactionDatas(transactionData);
        } else {
          console.log('FetchTransaction: No data or empty array', { data });
          setTransactionDatas([]);
        }
      } catch (e) {
        console.error('Error in FetchTransaction:', e);
        setTransactionDatas([]);
      }
    };
    
    if (FunAddress && chainId) {
      FetchTransaction();
      // Refresh every 10 seconds
      const interval = setInterval(() => {
        FetchTransaction();
      }, 10000);
      return () => clearInterval(interval);
    } else {
      setTransactionDatas([]);
    }
  }, [FunAddress, chainId]);
  const [selectedOption, setSelectedOption] = useState('Chat');
  const [holdersData, setHoldersData] = useState([]);
  const [holdersLoading, setHoldersLoading] = useState(false);
  // Normalize getTokenHolders response: { contract, chain_id, holders: [{ address, amount }], count, next_page }
  const normalizeHoldersResponse = (raw) => {
    const list = raw?.holders ?? [];
    if (!Array.isArray(list)) return [];
    return list
      .slice(0, 10)
      .map((item) => {
        const address = item?.address ?? '';
        const amountRaw = item?.amount ?? '0';
        const amountWei = BigInt(amountRaw);
        const amountHuman = Number(amountWei) / 1e18;
        return {
          address: String(address).trim(),
          amount: amountRaw,
          amountFormatted: amountHuman
        };
      })
      .filter((item) => item.address);
  };

  // Fetch holders when Holders tab is selected
  useEffect(() => {
    if (selectedOption !== 'Holders' || !tokenAddress) return;
    const fetchHolders = async () => {
      setHoldersLoading(true);
      try {
        const res = await fetch(
          `${apiUrl}/getTokenHolders?tokenContract=${encodeURIComponent(tokenAddress)}`,
          { method: 'GET' }
        );
        const data = await res.json();
        setHoldersData(normalizeHoldersResponse(data));
      } catch (e) {
        console.error('Fetch holders error:', e);
        setHoldersData([]);
      } finally {
        setHoldersLoading(false);
      }
    };
    fetchHolders();
  }, [selectedOption, tokenAddress]);
  // Pagination State and Logic for Transactions Table
  const [currentTransactionPage, setCurrentTransactionPage] = useState(1);
  const [transactionTotalPages, setTransactionTotalPages] = useState(0);
  const transactionItemsPerPage = 10;
  const [transactionPageNumbers, setTransactionPageNumbers] = useState([]);
  const calculateTransactionPageNumbers = (totalPages, currentPage) => {
    let pages = [];

    if (totalPages <= 4) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage === 1) {
        pages = [1, 2, '...', totalPages - 1, totalPages];
      } else if (currentPage === totalPages) {
        pages = [1, 2, '...', totalPages - 1, totalPages];
      } else {
        if (currentPage + 1 < totalPages) {
          if (currentPage + 1 === totalPages - 1) {
            pages = [currentPage - 1, currentPage, currentPage + 1, totalPages];
          } else {
            pages = [
              currentPage - 1,
              currentPage,
              currentPage + 1,
              '...',
              totalPages
            ];
          }
        } else if (currentPage < totalPages) {
          pages = [currentPage - 1, currentPage, currentPage + 1];
        } else {
          pages = [1, 2, '...', totalPages - 1, totalPages];
        }
      }
    }

    return pages;
  };

  const handleTransactionPageChange = newPageNumber => {
    setCurrentTransactionPage(newPageNumber);
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(transactionTotalPages, newPageNumber)
    );
  };

  useEffect(() => {
    const totalPages = Math.ceil(
      transactionDatas.length / transactionItemsPerPage
    );
    setTransactionTotalPages(totalPages);
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(totalPages, currentTransactionPage)
    );
  }, [transactionDatas]);
  const useScript = url => {
    useEffect(() => {
      const script = document.createElement('script');

      script.src = url;
      script.async = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }, [url]);
  };

  function isMobile() {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  }

  // Progress for THIS presale (FunAddress): getRisingPercent from contract + MC formula (matches board / LaunchpadCard)
  const bondingCurveProgressPercent = lpCreated
    ? 100
    : (virtualLpTokenAmounts < 1072999995 
      ? (marketCap * 100) / 116000 
      : 0);

  return (
    <div style={{ background: 'var(--page-bg)' }}>
      {useScript('../../charting_library/charting_library.js')}
      <TopBar />
      <div className="max-w-7xl mx-auto pt-28 pb-16 px-4 sm:px-6">
        <div className='flex flex-col lg:flex-row gap-6'>
          {/* Left Column */}
          <div className="lg:w-2/3">
            {/* Token Info Card */}
            <div className="rounded-xl p-6 mb-6" style={{
              background: 'var(--card-bg)',
              border: '1px solid transparent',
              backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              {/* First Line: Logo, Name, Address */}
              <div className="flex items-center gap-4 mb-4">
                <TokenLogo
                  logoUrl={tokenLogo}
                  tokenName={tokenName}
                  className="w-12 h-12 rounded-full"
                  alt={tokenName}
                />
                <div className="flex-1">
                  <h2 className="text-2xl font-bold mb-1" style={{ color: 'var(--text-primary)' }}>
                    {tokenName || 'Loading...'}
                  </h2>
                  {tokenAddress && (
                    <div className="flex items-center gap-2">
                      <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                        {tokenAddress.slice(0, 6)}...{tokenAddress.slice(-4)}
                      </span>
                      <button 
                        onClick={copyAddress(tokenAddress)} 
                        className="flex items-center hover:opacity-80 transition-opacity"
                        title="Copy address"
                      >
                        <img src={CopyIcon} alt="Copy" className="w-4 h-4" />
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Second Line: Price, Volume, MC */}
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <div className="text-sm mb-1" style={{ color: 'var(--text-secondary)' }}>Price</div>
                  <div className="text-lg font-bold" style={{ color: 'var(--text-primary)' }}>
                    ${tokenPrice && ethPrice ? formatPrice((tokenPrice * ethPrice) / 10 ** 12) : '0.000000'}
                  </div>
                </div>
                <div>
                  <div className="text-sm mb-1" style={{ color: 'var(--text-secondary)' }}>Volume</div>
                  <div className="text-lg font-bold" style={{ color: 'var(--text-primary)' }}>
                    ${formatNumber(volume || 0)}
                  </div>
                </div>
                <div>
                  <div className="text-sm mb-1" style={{ color: 'var(--text-secondary)' }}>MC</div>
                  <div className="text-lg font-bold" style={{ color: 'var(--text-primary)' }}>
                    ${formatNumber(marketCap || 0)}
                  </div>
                </div>
              </div>
            </div>

            {/* Chart Section */}
            <div className="rounded-xl overflow-hidden mb-6" style={{
              background: 'var(--card-bg)',
              border: '1px solid transparent',
              backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              {lpCreated ? (
                <iframe
                  src={`https://dexscreener.com/${chainNames1[chainId]}/${tokenAddress}?embed=1&trades=0&info=0&theme=${theme}`}
                  className="w-full h-[500px]"
                  title="chart"
                />
              ) : (
                <>
                  {tokenSymbol && tokenSymbol.trim() !== '' ? (
                    <Chart data={tokenPriceDatas || []} ethPrice={ethPrice || 1} interval="30" symbol={tokenSymbol} />
              ) : (
                    <div className="flex items-center justify-center h-full" style={{ minHeight: '400px', color: 'var(--text-secondary)' }}>
                      {tokenPriceDatas ? 'Loading chart...' : 'Waiting for token data...'}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* About Token Section */}
            <div className="rounded-xl p-6 mb-6" style={{
              background: 'var(--card-bg)',
              border: '1px solid transparent',
              backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              <h2 className="text-xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
                About {tokenName || 'Token'}
              </h2>
              <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
                {description || `${tokenName || 'Token'} is a revolutionary meme token built on the FlazePad platform. Join the community and be part of the future!`}
              </p>
              <div className="flex flex-wrap gap-3">
                {website && (
                  <a
                    href={website}
                    target="_blank"
                    rel="noreferrer"
                    className="px-4 py-2 rounded-lg text-sm font-medium transition-all hover:opacity-80"
                    style={{
                      background: 'var(--button-secondary-bg)',
                      border: '1px solid var(--button-secondary-border)',
                      color: 'var(--button-secondary-text)'
                    }}
                  >
                    Website
                  </a>
                )}
                {twitter && (
                  <a
                    href={twitter}
                    target="_blank"
                    rel="noreferrer"
                    className="px-4 py-2 rounded-lg text-sm font-medium transition-all hover:opacity-80"
                    style={{
                      background: 'var(--button-secondary-bg)',
                      border: '1px solid var(--button-secondary-border)',
                      color: 'var(--button-secondary-text)'
                    }}
                  >
                    Twitter
                  </a>
                )}
                {telegram && (
                  <a
                    href={telegram}
                    target="_blank"
                    rel="noreferrer"
                    className="px-4 py-2 rounded-lg text-sm font-medium transition-all hover:opacity-80"
                    style={{
                      background: 'var(--button-secondary-bg)',
                      border: '1px solid var(--button-secondary-border)',
                      color: 'var(--button-secondary-text)'
                    }}
                  >
                    Telegram
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:w-1/3 space-y-6">
            {/* Uniswap Banner */}
            {lpCreated && (
              <a
                href= {Number(chainId) === 97 
                  ? `https://pancakeswap.finance/swap?chain=${chainNames1[chainId]}&inputCurrency=tBNB&outputCurrency=${tokenAddress}` 
                  : `https://pancakeswap.finance/swap?chain=${chainNames1[chainId]}&inputCurrency=BNB&outputCurrency=${tokenAddress}`}
                target='_blank' rel="noreferrer"
              >
                <div className='rounded-xl overflow-hidden'>
                  <img src={uniswapBannerImg} className="w-full h-auto" />
                </div>
              </a>
            )}

            {/* Trade Card */}
            {!lpCreated && (
              <div className="rounded-xl p-6" style={{
                background: 'var(--card-bg)',
                border: '1px solid transparent',
                backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                boxShadow: 'var(--shadow)'
              }}>
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-xl font-bold" style={{ color: 'var(--text-primary)' }}>Trade {tokenSymbol}</h3>
                </div>

                <div className="space-y-4">
                  {/* Slippage Settings */}
                  <div className="p-4 rounded-lg" style={{
                    background: 'var(--section-bg)',
                    border: '1px solid var(--border-color)'
                  }}>
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>
                        Slippage Tolerance
                      </span>
                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          min="0"
                          max="50"
                          step="0.1"
                          value={slippage}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value) || 0;
                            if (value >= 0 && value <= 50) {
                              setSlippage(value);
                            }
                          }}
                          className="w-20 px-2 py-1 rounded text-right bg-transparent focus:outline-none border"
                          style={{
                            color: 'var(--text-primary)',
                            borderColor: 'var(--border-color)'
                          }}
                        />
                        <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>%</span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => setSlippage(0.1)}
                        className={`flex-1 py-1.5 px-3 rounded text-sm font-medium transition-all ${
                          slippage === 0.1 ? 'opacity-100' : 'opacity-70'
                        }`}
                        style={{
                          background: slippage === 0.1 ? 'var(--primary-gradient)' : 'var(--card-bg)',
                          border: '1px solid var(--border-color)',
                          color: slippage === 0.1 ? 'var(--button-text)' : 'var(--text-primary)'
                        }}
                      >
                        0.1%
                      </button>
                      <button
                        onClick={() => setSlippage(0.5)}
                        className={`flex-1 py-1.5 px-3 rounded text-sm font-medium transition-all ${
                          slippage === 0.5 ? 'opacity-100' : 'opacity-70'
                        }`}
                        style={{
                          background: slippage === 0.5 ? 'var(--primary-gradient)' : 'var(--card-bg)',
                          border: '1px solid var(--border-color)',
                          color: slippage === 0.5 ? 'var(--button-text)' : 'var(--text-primary)'
                        }}
                      >
                        0.5%
                      </button>
                      <button
                        onClick={() => setSlippage(1)}
                        className={`flex-1 py-1.5 px-3 rounded text-sm font-medium transition-all ${
                          slippage === 1 ? 'opacity-100' : 'opacity-70'
                        }`}
                        style={{
                          background: slippage === 1 ? 'var(--primary-gradient)' : 'var(--card-bg)',
                          border: '1px solid var(--border-color)',
                          color: slippage === 1 ? 'var(--button-text)' : 'var(--text-primary)'
                        }}
                      >
                        1%
                      </button>
                      <button
                        onClick={() => setSlippage(3)}
                        className={`flex-1 py-1.5 px-3 rounded text-sm font-medium transition-all ${
                          slippage === 3 ? 'opacity-100' : 'opacity-70'
                        }`}
                        style={{
                          background: slippage === 3 ? 'var(--primary-gradient)' : 'var(--card-bg)',
                          border: '1px solid var(--border-color)',
                          color: slippage === 3 ? 'var(--button-text)' : 'var(--text-primary)'
                        }}
                      >
                        3%
                      </button>
                    </div>
                    {(inputToken === 'ETH' && tokenOutAmount > 0) || (inputToken === 'TOKEN' && tokenOutAmount > 0) ? (
                      <div className="mt-3 pt-3 border-t" style={{ borderColor: 'var(--border-color)' }}>
                        <div className="flex justify-between items-center text-sm">
                          <span style={{ color: 'var(--text-secondary)' }}>Minimum received:</span>
                          <span style={{ color: 'var(--text-primary)' }}>
                            {(tokenOutAmount * (1 - slippage / 100)).toLocaleString(undefined, { maximumFractionDigits: 6 })} {inputToken === 'ETH' ? tokenSymbol : coinNames[chainId]}
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </div>

                  {/* Buy/Sell Tabs */}
                  <div className="flex gap-2 p-1 rounded-lg" style={{
                    background: 'var(--section-bg)',
                    border: '1px solid var(--border-color)'
                  }}>
                    <button
                      onClick={() => {
                        setInputToken('ETH')
                        setAmount('')
                        setTokenOutAmount(0)
                      }}
                      className="flex-1 py-2 px-4 rounded-md font-medium transition-all"
                      style={{
                        background: inputToken === 'ETH' ? 'var(--primary-gradient)' : 'transparent',
                        color: inputToken === 'ETH' ? 'var(--button-text)' : 'var(--text-secondary)',
                        opacity: inputToken === 'ETH' ? 1 : 0.7
                      }}
                    >
                      Buy
                    </button>
                    <button
                      onClick={() => {
                        setInputToken('TOKEN')
                        setAmount('')
                        setTokenOutAmount(0)
                      }}
                      className="flex-1 py-2 px-4 rounded-md font-medium transition-all"
                      style={{
                        background: inputToken === 'TOKEN' ? 'var(--primary-gradient)' : 'transparent',
                        color: inputToken === 'TOKEN' ? 'var(--button-text)' : 'var(--text-secondary)',
                        opacity: inputToken === 'TOKEN' ? 1 : 0.7
                      }}
                    >
                      Sell
                    </button>
                  </div>

                  {/* Input Section */}
                  {inputToken === 'ETH' ? (
                    // Buy Section
                    <>
                      <div className="p-4 rounded-lg" style={{
                        background: 'var(--section-bg)',
                        border: '1px solid var(--border-color)'
                      }}>
                        <div className="flex justify-between items-center mb-2">
                          <div className="flex items-center gap-3">
                            <img
                              src={ethIcon[chainId]}
                              className="w-8 h-8 rounded-full"
                              alt="BNB"
                            />
                            <span className="font-medium" style={{ color: 'var(--text-primary)' }}>
                              {coinNames[chainId]}
                            </span>
                          </div>
                          <div className="text-right">
                            <input
                              type="number"
                              placeholder="0"
                              value={tokenAmount || ''}
                              onChange={e => setAmount(e.target.value)}
                              className="w-32 text-right bg-transparent focus:outline-none text-lg font-bold"
                              style={{ color: 'var(--text-primary)' }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Quick Select Amount Tabs - Buy */}
                      <div className="flex gap-2 flex-wrap">
                        <button
                          onClick={() => {
                            setAmount('');
                            setTokenOutAmount(0);
                          }}
                          className="py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          Reset
                        </button>
                        <button
                          onClick={() => {
                            setAmount('0.01');
                          }}
                          className="py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          0.01
                        </button>
                        <button
                          onClick={() => {
                            setAmount('0.05');
                          }}
                          className="py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          0.05
                        </button>
                        <button
                          onClick={() => {
                            setAmount('0.1');
                          }}
                          className="py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          0.1
                        </button>
                        <button
                          onClick={() => {
                            setAmount('1');
                          }}
                          className="py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          1
                        </button>
                        <button
                          onClick={setMaxAmount}
                          className="py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          Max
                        </button>
                      </div>

                      {/* Balance Display */}
                      <div className="flex justify-between items-center text-sm py-2" style={{ color: 'var(--text-secondary)' }}>
                        <span>Balance: {Number(accountBalance).toLocaleString()}</span>
                      </div>

                      {/* Buy Button */}
                      {address === undefined ? (
                        <w3m-button />
                      ) : supportedChainIds.includes(Number(chainId)) ? (
                        <button
                          onClick={onTokenSwap}
                          className="w-full py-3 rounded-lg font-bold transition-all"
                          disabled={!address || (Number(tokenAmount) <= 0 || accountBalance < Number(tokenAmount))}
                          style={{
                            background: 'var(--primary-gradient)',
                            color: 'var(--button-text)',
                            opacity: !address || (Number(tokenAmount) <= 0 || accountBalance < Number(tokenAmount)) ? 0.5 : 1
                          }}
                        >
                          {creating ? (
                            <ClipLoader color="var(--button-text)" size={24} />
                          ) : (
                            'Buy'
                          )}
                        </button>
                      ) : (
                        <w3m-button />
                      )}

                      {/* Receive Amount */}
                      {tokenOutAmount > 0 && (
                        <div className="p-3 rounded-lg text-center" style={{
                          background: 'var(--section-bg)',
                          border: '1px solid var(--border-color)'
                        }}>
                          <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>You will receive</p>
                          <p className="text-lg font-bold mt-1" style={{ color: 'var(--text-primary)' }}>
                            {tokenOutAmount.toLocaleString(undefined, { maximumFractionDigits: 6 })} {tokenSymbol}
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    // Sell Section
                    <>
                      <div className="p-4 rounded-lg" style={{
                        background: 'var(--section-bg)',
                        border: '1px solid var(--border-color)'
                      }}>
                        <div className="flex justify-between items-center mb-2">
                          <div className="flex items-center gap-3">
                            <TokenLogo
                              logoUrl={tokenLogo}
                              tokenName={tokenName}
                              className="w-8 h-8 rounded-full"
                              alt="Token"
                            />
                            <span className="font-medium" style={{ color: 'var(--text-primary)' }}>
                              {tokenSymbol}
                            </span>
                          </div>
                          <div className="text-right">
                            <input
                              type="number"
                              placeholder="0"
                              value={tokenAmount || ''}
                              onChange={e => setAmount(e.target.value)}
                              className="w-32 text-right bg-transparent focus:outline-none text-lg font-bold"
                              style={{ color: 'var(--text-primary)' }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Quick Select Amount Tabs - Sell */}
                      <div className="flex gap-2">
                        <button
                          onClick={() => {
                            const amount = (Number(tokenBalance) * 0.25).toFixed(6);
                            setAmount(amount);
                          }}
                          className="flex-1 py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          25%
                        </button>
                        <button
                          onClick={() => {
                            const amount = (Number(tokenBalance) * 0.5).toFixed(6);
                            setAmount(amount);
                          }}
                          className="flex-1 py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          50%
                        </button>
                        <button
                          onClick={() => {
                            const amount = (Number(tokenBalance) * 0.75).toFixed(6);
                            setAmount(amount);
                          }}
                          className="flex-1 py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          75%
                        </button>
                        <button
                          onClick={() => {
                            const amount = Number(tokenBalance).toFixed(6);
                            setAmount(amount);
                          }}
                          className="flex-1 py-1.5 px-3 rounded text-sm font-medium transition-all"
                          style={{
                            background: 'var(--card-bg)',
                            border: '1px solid var(--border-color)',
                            color: 'var(--text-primary)'
                          }}
                        >
                          100%
                        </button>
                      </div>

                      {/* Balance Display */}
                      <div className="flex justify-between items-center text-sm py-2" style={{ color: 'var(--text-secondary)' }}>
                        <span>Balance: {Number(tokenBalance).toLocaleString()}</span>
                      </div>

                      {/* Sell Button */}
                      {address === undefined ? (
                        <w3m-button />
                      ) : supportedChainIds.includes(Number(chainId)) ? (
                        <button
                          onClick={onTokenSwap}
                          className="w-full py-3 rounded-lg font-bold transition-all"
                          disabled={!address || Number(tokenAmount) <= 0 || tokenBalance < Number(tokenAmount) || creating}
                          style={{
                            background: 'var(--primary-gradient)',
                            color: 'var(--button-text)',
                            opacity: !address || Number(tokenAmount) <= 0 || tokenBalance < Number(tokenAmount) || creating ? 0.5 : 1
                          }}
                        >
                          {creating ? (
                            <ClipLoader color="var(--button-text)" size={24} />
                          ) : (tokenAllowance === 0 || tokenAllowance < Number(tokenAmount)) ? (
                            'Approve token First'
                          ) : (
                            'Sell'
                          )}
                        </button>
                      ) : (
                        <w3m-button />
                      )}

                      {/* Receive Amount */}
                      {tokenOutAmount > 0 && (
                        <div className="p-3 rounded-lg text-center" style={{
                          background: 'var(--section-bg)',
                          border: '1px solid var(--border-color)'
                        }}>
                          <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>You will receive</p>
                          <p className="text-lg font-bold mt-1" style={{ color: 'var(--text-primary)' }}>
                            {tokenOutAmount.toLocaleString(undefined, { maximumFractionDigits: 6 })} {coinNames[chainId]}
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Progress Bar Card */}
            <div className="rounded-xl p-6" style={{
              background: 'var(--card-bg)',
              border: '1px solid transparent',
              backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              <div className="flex justify-between items-center text-sm mb-2">
                <span style={{ color: 'var(--text-secondary)' }}>Progress</span>
                <span style={{ color: 'var(--text-accent)' }}>
                  {bondingCurveProgressPercent.toFixed(2)}%
                </span>
              </div>
              <div className="w-full h-3 rounded-full overflow-hidden" style={{ background: 'var(--progress-container-bg)' }}>
                <div
                  className="h-full rounded-full transition-all duration-500"
                  style={{
                    width: `${bondingCurveProgressPercent}%`,
                    background: 'var(--progress-fill)'
                  }}
                />
              </div>
            </div>

            {/* Chat/Trades Section */}
            <div className="rounded-xl p-6" style={{
              background: 'var(--card-bg)',
              border: '1px solid transparent',
              backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              <div className="flex gap-4 mb-6 flex-wrap">
                <CustomRadioButton
                  value="Chat"
                  selectedValue={selectedOption}
                  handleSelect={setSelectedOption}
                />
                <CustomRadioButton
                  value="Trades"
                  selectedValue={selectedOption}
                  handleSelect={setSelectedOption}
                />
                <CustomRadioButton
                  value="Holders"
                  selectedValue={selectedOption}
                  handleSelect={setSelectedOption}
                />
              </div>

              {/* Holders Section */}
              {selectedOption === 'Holders' && (
                <div>
                  <div className="grid grid-cols-2 gap-4 p-3 mb-4 text-sm" style={{
                    background: 'var(--section-bg)',
                    borderRadius: '8px'
                  }}>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Address</div>
                    <div className="font-medium text-right" style={{ color: 'var(--text-primary)' }}>Amount</div>
                  </div>
                  {holdersLoading ? (
                    <div className="flex justify-center py-8">
                      <ClipLoader color="var(--text-accent)" size={32} />
                    </div>
                  ) : holdersData.length === 0 ? (
                    <div className="text-center py-6" style={{ color: 'var(--text-secondary)' }}>No holders data</div>
                  ) : (
                    <div className="space-y-2">
                      {holdersData.map((item, index) => (
                        <div key={item.address || index} className="grid grid-cols-2 gap-4 p-3 text-sm items-center" style={{
                          background: 'var(--section-bg)',
                          borderRadius: '8px'
                        }}>
                          <div className="flex items-center gap-1.5 min-w-0">
                            <a
                              href={scanLinks[chainId] + 'address/' + item.address}
                              target="_blank"
                              rel="noreferrer"
                              className="truncate"
                              style={{ color: 'var(--text-accent)' }}
                            >
                              {item.address.length >= 10
                                ? `${item.address.slice(0, 6)}...${item.address.slice(-4)}`
                                : item.address || '-'}
                            </a>
                            {item.address && FunAddress && item.address.toLowerCase() === FunAddress.toLowerCase() && (
                              <span className="flex-shrink-0" title="Presale contract">💧</span>
                            )}
                          </div>
                          <div className="text-right truncate" style={{ color: 'var(--text-primary)' }} title={item.amountFormatted.toLocaleString(undefined, { maximumFractionDigits: 6 })}>
                            {item.amountFormatted >= 1e9
                              ? (item.amountFormatted / 1e9).toFixed(2) + 'B'
                              : item.amountFormatted >= 1e6
                                ? (item.amountFormatted / 1e6).toFixed(2) + 'M'
                                : item.amountFormatted >= 1e3
                                  ? (item.amountFormatted / 1e3).toFixed(2) + 'K'
                                  : item.amountFormatted.toLocaleString(undefined, { maximumFractionDigits: 4 })}
                            {' '}{tokenSymbol}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Trades Section */}
              {selectedOption === 'Trades' && (
                <div>
                  <div className="grid grid-cols-4 gap-4 p-3 mb-4 text-sm" style={{
                    background: 'var(--section-bg)',
                    borderRadius: '8px'
                  }}>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Maker</div>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Type</div>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Amount</div>
                    <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Date</div>
                  </div>

                  {transactionDatas.length === 0 ? (
                    <div className="text-center py-6" style={{ color: 'var(--text-secondary)' }}>No Data</div>
                  ) : (
                    <>
                      <div className="space-y-2 mb-6">
                        {transactionDatas
                          .slice(
                            (currentTransactionPage - 1) * transactionItemsPerPage,
                            currentTransactionPage * transactionItemsPerPage
                          )
                          .map(({ Maker, Type, Amount, Date, Tx, txHash }, index) => (
                            <div key={Tx || index} className="grid grid-cols-4 gap-4 p-3 text-sm" style={{
                              background: 'var(--section-bg)',
                              borderRadius: '8px'
                            }}>
                              <a
                                href={scanLinks[chainId] + 'address/' + Maker}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center text-blue-500 "
                              >
                                {Maker.slice(0, 5) + '...' + Maker.slice(-3)}
                              </a>
                              <div style={{ color: '#ffffff' }}>
                                {Type}
                              </div>
                              <div style={{ color: 'var(--text-primary)' }}>
                                {Amount} {Type === 'Buy' ? coinNames[chainId] : tokenSymbol}
                              </div>
                              <div style={{ color: 'var(--text-primary)' }}>{Date}</div>
                            </div>
                          ))}
                      </div>

                      {/* Pagination */}
                      <div className="flex justify-center gap-2">
                        <button
                          className="px-3 py-1 rounded"
                          onClick={() => handleTransactionPageChange(1)}
                          style={{
                            background: 'var(--button-secondary-bg)',
                            border: '1px solid var(--button-secondary-border)',
                            color: 'var(--button-secondary-text)'
                          }}
                        >
                          &lt;&lt;
                        </button>
                        <button
                          className="px-3 py-1 rounded"
                          onClick={() => handleTransactionPageChange(Math.max(currentTransactionPage - 1, 1))}
                          style={{
                            background: 'var(--button-secondary-bg)',
                            border: '1px solid var(--button-secondary-border)',
                            color: 'var(--button-secondary-text)'
                          }}
                        >
                          &lt;
                        </button>
                        {transactionPageNumbers.map((pageNumber, index) => (
                          <button
                            key={index}
                            className={`px-3 py-1 rounded ${currentTransactionPage === pageNumber
                              ? 'bg-gradient-to-r from-blue-500 to-cyan-500'
                              : 'bg-transparent'}`}
                            onClick={() => typeof pageNumber === 'number' && handleTransactionPageChange(pageNumber)}
                            style={{
                              border: '1px solid var(--input-border)',
                              color: typeof pageNumber === 'number'
                                ? currentTransactionPage === pageNumber
                                  ? '#000000'
                                  : 'var(--text-primary)'
                                : 'var(--text-secondary)',
                              background: typeof pageNumber === 'number' && currentTransactionPage === pageNumber
                                ? 'var(--primary-gradient)'
                                : 'var(--card-bg)'
                            }}
                          >
                            {pageNumber}
                          </button>
                        ))}
                        <button
                          className="px-3 py-1 rounded"
                          onClick={() => handleTransactionPageChange(Math.min(currentTransactionPage + 1, transactionTotalPages))}
                          style={{
                            background: 'var(--button-secondary-bg)',
                            border: '1px solid var(--button-secondary-border)',
                            color: 'var(--button-secondary-text)'
                          }}
                        >
                          &gt;
                        </button>
                        <button
                          className="px-3 py-1 rounded"
                          onClick={() => handleTransactionPageChange(transactionTotalPages)}
                          style={{
                            background: 'var(--button-secondary-bg)',
                            border: '1px solid var(--button-secondary-border)',
                            color: 'var(--button-secondary-text)'
                          }}
                        >
                          &gt;&gt;
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* Chat Section */}
              {selectedOption === 'Chat' && (
                <div>
                  {chatHistory.length > 0 ? (
                    <div className="space-y-4">
                      {chatHistory.map(({ Sender, Content, Date, avatar }) => (
                        <div key={Sender + Date} className="p-4 rounded-lg" style={{
                          background: 'var(--section-bg)',
                          border: '1px solid var(--border-color)'
                        }}>
                          <div className="flex items-start gap-3">
                            <Jazzicon diameter={40} seed={jsNumberForAddress(Sender)} />
                            <div>
                              <div className="flex items-center gap-2">
                                <Link
                                  to={'/profile/?address=' + Sender}
                                  className="font-medium hover:underline"
                                  style={{ color: 'var(--text-primary)' }}
                                >
                                  {Sender.slice(0, 5) + '...' + Sender.slice(-3)}
                                </Link>
                                <span className="text-xs" style={{ color: 'var(--text-secondary)' }}>{Date}</span>
                              </div>
                              <p className="mt-2" style={{ color: 'var(--text-secondary)' }}>{Content}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-6" style={{ color: 'var(--text-secondary)' }}>No chat history</div>
                  )}
                  <div className="mt-6">
                    <SignMessage
                      FunAddress={FunAddress}
                      sender={address}
                      content={chatContent}
                      timestamp={(Date.now() / 1000).toFixed(0)}
                    />
                  </div>
                </div>
              )}
          </div>

            {/* Claim Card */}
            {/* <ClaimCard
              tokenName={tokenName}
              Logo={<TokenLogo logoUrl={tokenLogo} tokenName={tokenName} className="claim-eth-logo w-[20%]" />}
              banner={<TokenLogo logoUrl={tokenBanner} tokenName={tokenName} className="claim-eth-banner w-full" />}
              tokenAddress={tokenAddress}
              contractAddress={contractAddress}
              dexAddress="https://app.uniswap.org/swap"
              devAddress={devAddress}
              dexName="Uniswap"
              tokenSymbol={tokenSymbol}
              maxLimit={maxLimit}
              tokenDecimals={18}
              tokenTotalSupply={1000000000}
              maxBuyAmount={maxBuyAmount}
              tokenSupplyUSD={2 * virtualLp * ethPrice}
              tokenSupplyLiquidity={virtualTokenLp}
              tokenPrice={tokenPrice}
              tokenUnsoldTokens={'Burned 🔥'}
              tokenCover={tokenBanner}
              website={website}
              telegram={telegram}
              twitter={twitter}
              volume={volume}
              description={description}
              ethPrice={ethPrice}
              lpCreated={lpCreated}
              marketCap={marketCap}
              depositedAmount={depositedAmount}
            /> */}

            {/* Referral Card */}
            {/* <div className="rounded-xl p-6" style={{
              background: 'var(--card-bg)',
              border: '1px solid transparent',
              backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
              backgroundOrigin: 'border-box',
              backgroundClip: 'padding-box, border-box',
              boxShadow: 'var(--shadow)'
            }}>
              <h3 className="text-xl font-bold mb-4 text-center" style={{ color: 'var(--text-primary)' }}>
                Earn <span style={{ color: 'var(--text-accent)' }}>0.5%</span> of each trade
              </h3>
              <p className="text-center mb-4" style={{ color: 'var(--text-secondary)' }}>
                Share referral link with your friends and earn 0.5% of every trade they make.
              </p>

              <div className="flex gap-2 mb-6">
                <div className="flex-1 p-3 rounded-lg truncate" style={{
                  background: 'var(--input-bg)',
                  border: '1px solid var(--input-border)',
                  color: isTooltipDisplayed ? 'var(--text-accent)' : 'var(--text-primary)'
                }}>
                  {isTooltipDisplayed ? "Copied!" : referlink}
                </div>
                <button
                  className="p-3 rounded-lg flex items-center justify-center"
                  onClick={copyAddress(referlink)}
                  style={{
                    background: 'var(--button-secondary-bg)',
                    border: '2px solid var(--button-secondary-border)',
                    color: 'var(--button-secondary-text)',
                    minWidth: '44px'
                  }}
                >
                  <ClipboardIcon />
                </button>
              </div>

              
              {refUserAmount > 0 && (
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span style={{ color: 'var(--text-secondary)' }}>Total Referral Amounts:</span>
                    <span style={{ color: 'var(--text-primary)' }}>{totalRefAmounts.toFixed(8)} ETH</span>
                  </div>
                  <div className="flex justify-between">
                    <span style={{ color: 'var(--text-secondary)' }}>Total Ref Counts:</span>
                    <span style={{ color: 'var(--text-primary)' }}>{refCounts}</span>
                  </div>
                  <div className="flex justify-between">
                    <span style={{ color: 'var(--text-secondary)' }}>Your referral amounts:</span>
                    <span style={{ color: 'var(--text-primary)' }}>{refUserAmount.toFixed(8)} ETH</span>
                  </div>
                </div>
              )}
            </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default App;

const ClipboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    width="20"
    height="20"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-2m-2-2h-4m0 0h4m-4 0v2h4V3m-4 6h4"
    />
  </svg>
);
